import _, { update } from  "lodash"
const validators = {
  overlapFalse : (value , formData) => {
    return [true , {onlyOneAgreement:false}]
  },
  removeQuantible : (value, formData) => {
    return [true , {quantibleType : "NONE"}]
  },
  removeDates : (value,formData) => {
    return [true , {startDate:null,endDate:null,tenantId:null}]
  },



  // For rentalAgreement: endDate must be after startDate
greaterThanStartDate: (endDate, formData) => {
  if (!endDate || !formData.startDate) return [true];

  const start = new Date(formData.startDate);
  const end   = new Date(endDate);

  if (isNaN(start) || isNaN(end)) return [false];

  // must be greater than start date
  if (end < start) return [false];

  // must not exceed 365 days
  const diffDays = (end - start) / (1000 * 60 * 60 * 24);
  if (diffDays > 365) return [false];

  return [true];
},


  // For tenant: email must be valid if provided
  validEmail: (email) => {
    if (!email) return [true];
    // Simple email regex
    return [/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)];
  },

  // For invoice: periodEnd must be after periodStart
  periodEndAfterStart: (periodEnd, formData) => {
    if (!periodEnd || !formData.periodStart) return true;
    return [new Date(periodEnd) > new Date(formData.periodStart)];
  } ,
  dirtyCheck : (current , initial) => {
    if (initial == null){
      initial = {}
    }
    if (Object.keys(current).length != Object.keys(initial).length){
      return [true]
    }
    var allKeys = new Set([...Object.keys(current) , ...Object.keys(initial)])
    for (var key of allKeys){
      if ((key in current) && (key in initial) ){
        if (current[key] !== initial[key]) {
          return [true]
        }
      } else {
        return [true]
      }
    }
    return [false]
  } ,
  pickDataToUpdate:(current , initial)=>{
    if (initial == null){
      initial = {}
    }
    var updatedData = {}
    for (var key of Object.keys(current)){
      if (key.toLowerCase().endsWith("id")){
        updatedData[key] = current[key]
        continue
      }
      if (!(key in initial)){
        updatedData[key] = current[key]
      } else {
        // if(!_.isEqual(current[key],initial[key])){
          updatedData[key] = current[key]
        // }
      }
    }
    return updatedData
  }
};

export default validators;
